export default function purgeAttachments (nodeList) {
  if (nodeList.length === 0) return;

  nodeList.forEach( (node) => {
    node.addEventListener('ajax:success', (e) => {
      e.target.closest("[data-purge]").remove()
    })
  })
}
